import _isFunction from 'lodash/isFunction';
import _isPlainObject from 'lodash/isPlainObject';
import _merge from 'lodash/merge';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

/* Middleware */
import cacheRemoveMiddleware from '@util/middlewares/cache-remove-middleware';
import fetchable from '@common/fetchable';
import sentryMiddleware from '@util/middlewares/sentry-middleware';

const enhancers = composeWithDevTools(
  /**
   * Order of middlewares is important, so only change if you're sure
   */
  applyMiddleware(fetchable.middleware, cacheRemoveMiddleware, sentryMiddleware)
);

let store;
let allReducers = {};

const customCombineReducers = reducers =>
  combineReducers(
    Object.keys(reducers).reduce((acc, reducerName) => {
      /**
       * If current reducer is function, add to accumulator so that it will be combined as normal
       */
      if (_isFunction(reducers[reducerName])) {
        return { ...acc, [reducerName]: reducers[reducerName] };
      }
      /**
       * If current reducer is an object, call customCombineReducers and set result to new reducer name
       */
      if (_isPlainObject(reducers[reducerName])) {
        return {
          ...acc,
          [reducerName]: customCombineReducers(reducers[reducerName])
        };
      }

      return acc;
    }, {})
  );

export const configureStore = reducers => {
  allReducers = _merge(reducers);

  store = createStore(customCombineReducers(allReducers), enhancers);
  return store;
};

export const injectAsyncReducers = asyncReducers => {
  // We should only have access to shape of reducers via allReducers before they're combined
  allReducers = _merge(allReducers, asyncReducers);

  if (store) {
    store.replaceReducer(customCombineReducers(allReducers));
  }
};
